import { Icon } from '@chakra-ui/icons'

const Info = props => (
    <Icon viewBox="0 0 24 24" fill={'none'} {...props}>
        <g clipPath="url(#clip0_164043_130293)">
            <path
                d="M2.75 2.75H21.25V21.25H2.75V2.75Z"
                stroke="#5C5C5C"
                strokeWidth="1.5"
            />
            <path
                d="M12 17V11.5M12 10.5V8"
                stroke="#5C5C5C"
                strokeWidth="1.5"
            />
        </g>
        <defs>
            <clipPath id="clip0_164043_130293">
                <rect
                    width="20"
                    height="20"
                    fill="white"
                    transform="translate(2 2)"
                />
            </clipPath>
        </defs>
    </Icon>
)

const Camcorder = props => {
    return (
        <Icon viewBox="0 0 24 24" fill={'none'} {...props}>
            <rect width="24" height="24" fill="white" />
            <path d="M15 8H5V16.5H15V8Z" stroke="#333333" strokeWidth="3" />
            <path
                d="M15.4444 10.7222L19.4444 8.5V16.5L15 14.7222"
                stroke="#333333"
                strokeWidth="2.66667"
            />
        </Icon>
    )
}

const ScreenRecorder = props => {
    return (
        <Icon viewBox="0 0 24 24" fill={'none'} {...props}>
            <path
                d="M4 7V9.22222V17H20V7H4Z"
                stroke="#333333"
                strokeWidth="3"
            />
            <mask id="path-2-inside-1_161711_127413" fill="white">
                <path d="M10 14.5V11H17V14.5H14.6667H10Z" />
            </mask>
            <path d="M10 14.5V11H17V14.5H14.6667H10Z" fill="#333333" />
            <path
                d="M10 11V5.75H4.75V11H10ZM10 14.5H4.75V19.75H10V14.5ZM17 14.5V19.75H22.25V14.5H17ZM17 11H22.25V5.75H17V11ZM4.75 11V14.5H15.25V11H4.75ZM10 19.75H14.6667V9.25H10V19.75ZM14.6667 19.75H17V9.25H14.6667V19.75ZM22.25 14.5V11H11.75V14.5H22.25ZM17 5.75H10V16.25H17V5.75Z"
                fill="#333333"
                mask="url(#path-2-inside-1_161711_127413)"
            />
        </Icon>
    )
}

const FullScreen = props => {
    return (
        <Icon viewBox="0 0 24 24" fill={'none'} {...props}>
            <path
                d="M4 10.5L4 7H8.5M4 13.5V17H8.5M15.5 7H20V10.5M20 13.5V17H15.5"
                stroke="currentColor"
                strokeWidth="3"
            />
        </Icon>
    )
}

const CircleTick = props => (
    <Icon viewBox="0 0 27 27" {...props}>
        <circle
            cx="13.5"
            cy="13.5"
            r="12"
            fill="currentColor"
            stroke="currentColor"
            strokeWidth="3"
        />
        <g clipPath="url(#clip0_157702_125155)" fill="none">
            <path
                d="M7.8125 12.9026L12.0312 17.1213L20.0901 9.0625"
                stroke="white"
                strokeWidth="3"
            />
        </g>
        <defs>
            <clipPath id="clip0_157702_125155">
                <rect
                    width="18"
                    height="18"
                    fill="white"
                    transform="translate(5 4)"
                />
            </clipPath>
        </defs>
    </Icon>
)

export { Camcorder, CircleTick, FullScreen, Info, ScreenRecorder }
